module.exports = __webpack_public_path__ + "img/X-battle-the-maelstrom.f7e189fa.jpg";